var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.loading
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "el-row process-body",
            },
            [
              _c(
                "div",
                { staticClass: "el-col el-col-14 process-form-content" },
                [
                  _c("div", { class: _vm.processTitleClasses }, [
                    _vm._v(_vm._s(_vm.form.templateName)),
                  ]),
                  _vm.form.remark
                    ? _c(
                        "div",
                        { staticClass: "process-remark" },
                        [
                          _c("el-icon", {
                            staticClass: "el-icon-warning-outline",
                          }),
                          _vm._v(_vm._s(_vm.form.remark) + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.$route.query.type !== "edit"
                    ? _c("history-templates", {
                        attrs: {
                          "template-id": _vm.form.id,
                          disabled: _vm.loading,
                        },
                        on: {
                          select: _vm.applyHistory,
                          busy: function ($event) {
                            _vm.historyLoading = $event
                          },
                        },
                      })
                    : _vm._e(),
                  _c("form-render", {
                    key: _vm.formEpoch,
                    ref: "form",
                    staticClass: "process-form",
                    attrs: { forms: _vm.displayForms },
                    model: {
                      value: _vm.formData,
                      callback: function ($$v) {
                        _vm.formData = $$v
                      },
                      expression: "formData",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "el-col el-col-10 process-timeline" }, [
                _c(
                  "div",
                  [
                    _c("div", { staticClass: "title-timeline" }, [
                      _vm._v("审批流程"),
                    ]),
                    _c(
                      "el-timeline",
                      { staticClass: "my-timeline" },
                      _vm._l(_vm.cc, function (activity, index) {
                        return _c(
                          "el-timeline-item",
                          {
                            key: index,
                            staticClass: "task",
                            attrs: { icon: activity.icon, size: "large" },
                          },
                          [
                            !activity.hasOwnProperty("options")
                              ? _c(
                                  "div",
                                  { staticClass: "process-node-content" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "process-node-title" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "node-title" },
                                          [_vm._v(_vm._s(activity.title))]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "node-desc" },
                                          [_vm._v(_vm._s(activity.desc))]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "node-desc" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.activityMode(activity))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "process-node-con",
                                        class: {
                                          "process-node-con-single":
                                            !activity.multiple,
                                        },
                                      },
                                      [
                                        activity.nobodyText
                                          ? _c(
                                              "div",
                                              { staticClass: "no-user" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "item-user" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "user-photo",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass: "avatar",
                                                          attrs: {
                                                            src: require("@/assets/def_avatar_84px.png"),
                                                            alt: "",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c("div", [
                                                  _c(
                                                    "span",
                                                    { staticClass: "hot" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          activity.nobodyTitle
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "," +
                                                      _vm._s(
                                                        activity.nobodyText
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        activity.users &&
                                        activity.users.length > 6
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "item-user",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.lookMore(
                                                      activity.users
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "user-photo" },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "avatar look-more",
                                                      attrs: {
                                                        src: require("@/assets/img/formDesign/icon_shenpiren.png"),
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "look-more" },
                                                  [_vm._v("查看全部")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._l(
                                          activity.users,
                                          function (user, index) {
                                            return index < 6
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "item-user",
                                                    attrs: {
                                                      title:
                                                        (user.serial || "") +
                                                        (user.name ||
                                                          user.reallyName),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "user-photo",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass: "avatar",
                                                          attrs: {
                                                            src: require("@/assets/def_avatar_84px.png"),
                                                            alt: "",
                                                          },
                                                        }),
                                                        !user.disabled &&
                                                        activity.isEdit
                                                          ? _c("i", {
                                                              staticClass:
                                                                "close el-icon-close",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.delUser(
                                                                      activity.users,
                                                                      index,
                                                                      activity.id
                                                                    )
                                                                  },
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        index <
                                                          Math.min(
                                                            activity.users
                                                              .length - 1,
                                                            5
                                                          ) || activity.isEdit
                                                          ? [
                                                              activity.mode ===
                                                              "AND"
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "i-and",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "+"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : activity.mode ===
                                                                  "OR"
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "i-or",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "/"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "name-con",
                                                      },
                                                      [
                                                        user.serial
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "serial",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    user.serial
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "name ellipsis",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                user.roleName ||
                                                                  user.name ||
                                                                  user.reallyName
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        activity.isEdit &&
                                        (activity.multiple ||
                                          0 === activity.users.length)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "add-user",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addUser(activity)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-plus",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              : _c(
                                  "el-radio-group",
                                  {
                                    attrs: { size: "mini" },
                                    model: {
                                      value: activity.id,
                                      callback: function ($$v) {
                                        _vm.$set(activity, "id", $$v)
                                      },
                                      expression: "activity.id",
                                    },
                                  },
                                  _vm._l(activity.options, function (d, index) {
                                    return _c("el-radio-button", {
                                      key: index,
                                      attrs: { label: d.title, value: d.id },
                                    })
                                  }),
                                  1
                                ),
                            activity.isEmpty
                              ? _c("div", { staticClass: "err-tips" }, [
                                  _vm._v("请选择" + _vm._s(activity.title)),
                                ])
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: {
          title: "指定成员",
          multiple: this.selectedNode.multiple || !1,
        },
        on: { ok: _vm.selected },
      }),
      _c("pop-user-more", { ref: "popUserMore", attrs: { title: "查看全部" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }